// noinspection JSUnusedGlobalSymbols

import Dayjs from 'dayjs'
import Cookies from 'js-cookie'
import Form from '../../../client/form.js'
import Helper from '../../../client/helper.js'
import Network from '../../../client/network.js'

export default class
{
	static canvas

	static init()
	{
		$(document).on('opening', '.remodal', () =>
		{
			$('.remodal select').removeClass('__no-select')
			Form.select_picker()
		})

		this.canvas = new fabric.Canvas('sign')

		this.canvas.isDrawingMode = true
		this.canvas.freeDrawingBrush.width = 3
		this.canvas.freeDrawingBrush.color = this.pen_color

		this._init_drag()
		this._align_timetable_rows()
		$(window).on('load', () => this._align_timetable_rows())

		this._set_time_border()
		setInterval(this._set_time_border, 60000)
	}

	static _init_drag()
	{
		let _drag
		let _start_cell

		$('[draggable="true"]').on('dragstart', (event) =>
		{
			_drag = $(event.currentTarget)
			_start_cell = _drag.parent().parent()

			_drag.addClass('_dragging')
			$('#timetable').addClass('_hovered')
		}).on('dragend', () =>
		{
			_drag.removeClass('_dragging')
			$('#timetable').removeClass('_hovered')
		})

		$('#timetable td').on('dragenter', (event) =>
		{
			event.preventDefault()
			$(event.currentTarget).addClass('_dragged')
		}).on('dragleave', (event) =>
		{
			$(event.currentTarget).removeClass('_dragged')
		}).on('dragover', (event) =>
		{
			event.preventDefault()
		}).on('drop', (event) =>
		{
			event.preventDefault()

			const cell = $(event.currentTarget)
			cell.removeClass('_dragged')

			const staff = cell.data('staff_name')
			const time = cell.data('time')

			if(cell[0] === _start_cell[0]) return
			$(event.currentTarget).find('.__drop').append(_drag)
			this._align_timetable_rows()

			Helper.confirm(Helper.message('#message-change_confirm', [staff, time]), () =>
			{
				const visit = _drag.data('visit')

				$.post('/visit/max', {visit: visit, time: time, __action: 'max'}, (response) =>
				{
					const save = () =>
					{
						const staff_id = $(event.currentTarget).data('staff')
						const data = new FormData()

						data.set('__action', 'alter')
						data.set('visit', visit)
						data.set('time', time)
						data.set('staff', staff_id)

						Network.post(
							location.pathname,
							data,
							(success) =>
							{
								if(success) setTimeout(() => location.reload(), 2000)
								else
								{
									_start_cell.find('.__drop').append(_drag)
									this._align_timetable_rows()
								}
							},
							false,
						)
					}

					if(response.message === '') save()
					else Helper.confirm(response.message, save)
				})
			}, () =>
			{
				_start_cell.find('.__drop').append(_drag)
				this._align_timetable_rows()
			})
		})
	}

	/**
	 * Aligns timetable lane heights across every time cell in each staff row.
	 *
	 * @returns {void}
	 * @note Measures rendered card content and changes presentation only; booking data is untouched.
	 */
	static _align_timetable_rows()
	{
		$('#timetable tr._visit_staff_row').each((index, row) =>
		{
			const drops = $(row).find('td > .__drop')
			if(drops.length === 0) return

			drops.css('grid-template-rows', '')

			const lane_count = Number(drops[0].style.getPropertyValue('--visit-lanes')) || 1
			const heights = Array(lane_count).fill(90)

			$(row).find('._cell').each((card_index, card) =>
			{
				const lane = Number(card.dataset.lane)
				if(lane < 1 || lane > lane_count) return

				heights[lane - 1] = Math.max(heights[lane - 1], card.scrollHeight)
			})

			drops.css('grid-template-rows', heights.map((height) => `${height}px`).join(' '))
		})
	}

	static _set_time_border()
	{
		if($('#open').length === 0)
		{
			$('#time_border').hide()
			return
		}

		const now = Dayjs()

		const [hour, minute] = $('#open').data('start').split(':')
		const adjust = (now.hour() - Number(hour)) * 60 + (now.minute() - Number(minute))

		const option = {
			cell_minute    : 30,
			cell_width     : 100,
			name_cell_width: 100,
		}

		const position = adjust / option.cell_minute * option.cell_width + option.name_cell_width
		$('#time_border').css('left', `${Math.round(position)}px`)
	}

	static canvas_edit = {}

	static canvas_history = {}

	static canvas_history_position = {}

	static canvas_erase = {}

	static pen_color = '#555'

	static pen_width = {
		normal: 3,
		eraser: 20,
	}

	static init_edit(visit_id, type)
	{
		this.set_type(type)

		if($('#customer').val() === '') $('#customer-link').hide()
		else $('#customer-link').show()

		$('#form canvas').each((index, element) =>
		{
			const [, id] = element.id.split('-')
			const image = new Image()

			image.onload = () =>
			{
				const update = (id, image_loaded) =>
				{
					if(this.canvas_history_position[id] < this.canvas_history[id].length - 1)
					{
						this.canvas_history[id] = this.canvas_history[id].slice(0, this.canvas_history_position[id] + 1)
					}

					this.canvas_history[id][++this.canvas_history_position[id]] = JSON.stringify(this.canvas_edit[id])

					if(image_loaded === true)
					{
						this.canvas_edit[id].backgroundImage.erasable = false
					}
					else
					{
						this.canvas_edit[id].renderAll()
						$(`#preview-${id}`)[0].src = this.canvas_edit[id].toDataURL()

						$(`#drawn_memo-${id}`).val(1)
					}
				}

				element.width = image.width
				element.height = image.height

				this.canvas_erase[id] = false

				this.canvas_history[id] = []
				this.canvas_history_position[id] = -1

				this.canvas_edit[id] = new fabric.Canvas(element.id)

				this.canvas_edit[id].isDrawingMode = true
				this.canvas_edit[id].freeDrawingBrush.width = this.pen_width.normal
				this.canvas_edit[id].freeDrawingBrush.color = this.pen_color

				this.canvas_edit[id].getContext('2d').drawImage(image, 0, 0)
				this.canvas_edit[id].setBackgroundImage(image.src, update.bind(this, id, true))

				const memo_image = new Image()

				memo_image.onload = () => this.canvas_edit[id].add(new fabric.Image(memo_image))
				memo_image.src = `/visit_image/${visit_id}/${id}`

				this.canvas_edit[id].on('path:created', update.bind(this, id))
			}

			image.src = `/upload/memo/${id}.png?${$(element).data('modified')}`
		})

		if($('#form [name="customer_id"]').val() === '')
		{
			$('#form [name="customer_ruby"]').prop('disabled', false).removeClass('hidden')
			$('#form [name="customer_phone"]').prop('disabled', false).removeClass('hidden')
		}
	}

	static clear_sign()
	{
		this.canvas.clear()
		$('#survey_sign').val('')
	}

	static clear_sign_edit(id)
	{
		this.canvas_edit[id].clear()
		const image = new Image()

		image.onload = () =>
		{
			this.canvas_edit[id].getContext('2d').drawImage(image, 0, 0)
			this.canvas_edit[id].setBackgroundImage(image.src)
		}

		image.src = `/upload/memo/${id}.png`
	}

	static canvas_modified = false

	static open_survey(id, event)
	{
		event.preventDefault()
		event.stopPropagation()

		window.open(`/visit_survey/${id}`)
		location.href = `/visit/${id}`
	}

	static submit(form)
	{
		$('canvas').each((index, element) =>
		{
			const [, id] = element.id.split('-', 2)
			if(!id) return

			$(`#image-${id}`).val(this.canvas_edit[id].toDataURL())
		})

		$.post('/visit/max', {
			visit   : form.id.value,
			date    : form.visit_time_day[0].value,
			time    : `${form.visit_time_hour[0].value}:${form.visit_time_minute[0].value}`,
			__action: 'max',
		}, (response) =>
		{
			const save = () =>
			{
				return App.common.Network.form_post(form, (success, payload) =>
				{
					App.common.Ui.reload(success, `/visit/?day=${payload?.date}`)
				}, false)
			}

			if(response.message === '') save()
			else Helper.confirm(response.message, save)
		})

		return false
	}

	static draw_eraser(id)
	{
		this.canvas_erase[id] = !this.canvas_erase[id]
		$(`#erase_${id}`).toggleClass('_erasing')

		if(this.canvas_erase[id])
		{
			if(this.canvas_history[id].length > 0)
			{
				this.canvas_edit[id].freeDrawingBrush = new fabric.EraserBrush(this.canvas_edit[id])
				this.canvas_edit[id].freeDrawingBrush.width = this.pen_width.eraser
			}
			else
			{
				this.canvas_edit[id].freeDrawingBrush.width = 0
				this.canvas_edit[id].freeDrawingBrush.color = '#fff'
			}
		}
		else
		{
			this.canvas_edit[id].freeDrawingBrush = new fabric.PencilBrush(this.canvas_edit[id])
			this.canvas_edit[id].freeDrawingBrush.width = this.pen_width.normal
		}
	}

	static draw_clear(id)
	{
		Helper.confirm(Helper.message('#message-delete_confirm'), () =>
		{
			if(this.canvas_history_position[id] < 0) return

			this.canvas_edit[id].clear().renderAll()
			this.canvas_history_position[id] = 0

			const history = this.canvas_history[id][this.canvas_history_position[id]]
			this.canvas_edit[id].loadFromJSON(history)

			this.canvas_edit[id].renderAll()
			setTimeout(() => $(`#preview-${id}`)[0].src = this.canvas_edit[id].toDataURL(), 300)
		})
	}

	static draw_undo(id)
	{
		if(this.canvas_history_position[id] <= 0) return

		this.canvas_edit[id].clear().renderAll()
		this.canvas_history_position[id]--

		const history = this.canvas_history[id][this.canvas_history_position[id]]
		this.canvas_edit[id].loadFromJSON(history)

		this.canvas_edit[id].renderAll()
		setTimeout(() => $(`#preview-${id}`)[0].src = this.canvas_edit[id].toDataURL(), 300)
	}

	static draw_redo(id)
	{
		if(this.canvas_history_position[id] >= this.canvas_history[id].length - 1) return

		this.canvas_edit[id].clear().renderAll()
		this.canvas_history_position[id]++

		const history = this.canvas_history[id][this.canvas_history_position[id]]
		this.canvas_edit[id].loadFromJSON(history)

		this.canvas_edit[id].renderAll()
		setTimeout(() => $(`#preview-${id}`)[0].src = this.canvas_edit[id].toDataURL(), 300)
	}

	static change(type, day)
	{
		document.cookie = `staff_visit=''; path=/; max-age=0`

		$(`#${type}`).val(day)
		$(`#${type}`)[0].form.submit()
	}

	static change_customer(value)
	{
		if(value === '') $('#customer-link').hide()
		else $('#customer-link').show()

		const input = {
			ruby : $('#form [name="customer_ruby"]'),
			phone: $('#form [name="customer_phone"]'),
		}

		if($('#form [name="customer_id"]').val() === '')
		{
			input.ruby.prop('disabled', false).removeClass('hidden')
			input.phone.prop('disabled', false).removeClass('hidden')
		}
		else
		{
			input.ruby.prop('disabled', true).addClass('hidden')
			input.phone.prop('disabled', true).addClass('hidden')
		}

		$('#customer-link').attr('href', `/customer/${value}`)
	}

	static add_image()
	{
		const clone = $('#image_template').clone()

		clone.attr('id', null)
		clone.removeClass('hidden')

		let max = 0

		$('#image').find('img').each((index, element) =>
		{
			max = Number(element.id.replace(/^preview/, '')) + 1
		})

		const id = `preview${max}`
		clone.find('img').attr('id', id)

		const input = clone.find('input')
		input.prop('disabled', false)

		input.jfilestyle({
			input   : false,
			text    : Helper.message('#message-select'),
			_preview: `#${id}`,
			onChange: function(files)
			{
				const preview = $(this._preview)[0]
				if(files.length > 0) preview.src = URL.createObjectURL(files[0])
			},
		})

		$('#image').append(clone)
	}

	static remove_image(node)
	{
		Helper.confirm(Helper.message('#message-delete_confirm_image'), () => $(node).remove())
	}

	static add_visit(time, staff, event)
	{
		event.preventDefault()
		location.href = `/visit/0?time=${time}&staff=${staff}`
	}

	static set_type(type)
	{
		if(type === 'reservation')
		{
			$('._reservation').show()
			$('._reservation_disable').prop('disabled', true)

			$('._break').hide()
			$('._break_disable').prop('disabled', false)

			$('._break input[name="visit_time_day"]').prop('required', false).prop('disabled', true)
			$('._reservation input[name="visit_time_day"]').prop('required', true).prop('disabled', false)

			$('#duration').prop('required', true)
		}
		else
		{
			$('._reservation').hide()
			$('._reservation_disable').prop('disabled', false)

			$('._break').show()
			$('._break_disable').prop('disabled', true)

			$('._break input[name="visit_time_day"]').prop('required', true).prop('disabled', false)
			$('._reservation input[name="visit_time_day"]').prop('required', false).prop('disabled', true)

			$('#duration').prop('required', false)
		}
	}

	static toggle_off(checked)
	{
		if(checked) Cookies.set('show_off_visit', '1', {expires: 365, path: '/'})
		else Cookies.remove('show_off_visit')

		location.reload()
	}

	static change_menu(select)
	{
		let duration = 0

		$(select).find('option:checked').each((index, element) =>
		{
			duration += Number($(element).data('duration'))
		})

		select.form.duration.value = duration
	}

	static change_memo(select)
	{
		$(`[data-memo]`).hide()
		for(const id of select.tomselect.getValue()) $(`[data-memo="${id}"]`).show()
	}

	static cancel_type(type, portal, extra)
	{
		if(type === '' || portal !== 'salonboard' || extra !== 'smart_payment')
		{
			$('#cancel_check').hide()
			return
		}


		$('#cancel_check').show()
	}
}
